"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NuiLogValidator = exports.APPLICATION_LOG_FORMAT_V2 = void 0;
var _ = _interopRequireDefault(require("ajv/dist/2020"));
var _applicationLogFormat_V2_Schema = _interopRequireDefault(require("./applicationLogFormat_V2_Schema.json"));
var _excluded = ["strict", "removeAdditional"];
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/**
 * Application log format schema version 2.
 * This constant contains the JSON schema definition for validating log records
 * according to the application log format specification version 2:
 * https://wiki.one.int.sap/wiki/pages/viewpage.action?pageId=3286770416
 *
 * @constant {Object} APPLICATION_LOG_FORMAT_V2 - The JSON schema for log format validation
 */
var APPLICATION_LOG_FORMAT_V2 = exports.APPLICATION_LOG_FORMAT_V2 = _applicationLogFormat_V2_Schema.default;

/**
 * NUI Log Validator class for validating log records against JSON schemas.
 * This class provides schema validation functionality using AJV (Another JSON Schema Validator).
 */
var NuiLogValidator = exports.NuiLogValidator = /*#__PURE__*/function () {
  /**
   * Creates a new NuiLogValidator instance.
   *
   * @param {Object} [options] - Configuration options for the validator
   * @param {boolean} [options.strict=true] - Enable strict mode validation
   * @param {boolean} [options.removeAdditional=true] - Remove additional properties not defined in schema
   */
  function NuiLogValidator() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    _classCallCheck(this, NuiLogValidator);
    var _options$strict = options.strict,
      strict = _options$strict === void 0 ? true : _options$strict,
      _options$removeAdditi = options.removeAdditional,
      removeAdditional = _options$removeAdditi === void 0 ? true : _options$removeAdditi,
      otherOptions = _objectWithoutProperties(options, _excluded);
    this.ajv = new _.default(_objectSpread({
      strict: strict,
      removeAdditional: removeAdditional
    }, otherOptions));
  }

  /**
   * Validates a schema using AJV's validateSchema method.
   *
   * @param {Object} schema - The JSON schema to validate
   * @returns {boolean} True if the schema is valid, false otherwise
   * @throws {Error} Throws an error with details if the schema is invalid
   */
  _createClass(NuiLogValidator, [{
    key: "validateSchema",
    value: function validateSchema(schema) {
      var isValidSchema = this.ajv.validateSchema(schema);
      if (!isValidSchema) {
        throw new Error("Invalid schema provided: ".concat(this.ajv.errorsText(this.ajv.errors)));
      }
      return isValidSchema;
    }

    /**
     * Validates a log record against a provided schema.
     *
     * @param {Object} record - The log record object to validate and potentially modify
     * @param {Object} [schema={}] - The JSON schema to validate against
     * @returns {Object} The validated (and potentially modified) record object
     * @throws {Error} Throws validation errors if the schema is invalid
     */
  }, {
    key: "validate",
    value: function validate(record) {
      var schema = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      // Validate the schema first
      this.validateSchema(schema);

      // Compile the schema
      var validateFn = this.ajv.compile(schema);

      // Validate the record against the schema
      validateFn(record);
      return record;
    }
  }]);
  return NuiLogValidator;
}();